import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { trackByProp } from '@nx-massaud/utils';
import {
  ComponentSwitcherConfigOptions,
  ComponentSwitcherDirective,
} from '@nx-massaud/component-switcher';
import { ComponentSwitcherPipe } from '@nx-massaud/ui/switcher-pipes';
import { ResponsiveClassesDirective } from '@nx-massaud/responsive';
import { ListScrollLoaderDirective } from '@madeinlune/massaud-json-api-bridge';

interface GridListItem {
  id: string;
  type: string;
  class?: string;
}

@Component({
  selector: 'msd-ui-grid-list',
  standalone: true,
  imports: [
    CommonModule,
    ComponentSwitcherDirective,
    ComponentSwitcherPipe,
    ResponsiveClassesDirective,
    ListScrollLoaderDirective,
  ],
  template: `
    <ul [nxMassaudResponsiveClasses]="classes" listScrollLoader>
      <ng-template
        ngFor
        [ngForOf]="data"
        let-item
        [ngForTrackBy]="trackByItemId"
        let-index="index"
      >
        <li
          [ngClass]="item.class ?? ''"
          (click)="clickItem.emit(index)"
          class="b-grid-item"
        >
          <ng-template
            *nxMassaudComponentSwitcher="
              item | componentSwitcher : componentSwitcherOptions
            "
          ></ng-template>
        </li>
      </ng-template>
    </ul>
  `,
  styleUrls: ['./grid-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridListComponent implements OnChanges {
  @Output()
  clickItem: EventEmitter<number> = new EventEmitter<number>();

  @Input()
  data: GridListItem[] | undefined;

  @Input()
  componentSwitcherOptions: ComponentSwitcherConfigOptions | undefined;

  @Input()
  classes: string[] = [];

  trackByItemId = trackByProp<GridListItem>('id');

  ngOnChanges(changes: SimpleChanges): void {
    console.log({ changes });
  }
}
